import axios from "axios";

const AdImagesCall = async (
  adImage,
  countries,
  image_En_Data,
  image_Ar_Data,
  adPlace
) => {
  try {
    const formData = new FormData();
    formData.append("adImage", JSON.stringify(adImage));
    formData.append("countries", JSON.stringify(countries));
    
    if (image_En_Data && image_En_Data !== "undefined" && image_En_Data !== "") {
      formData.append("image_en", image_En_Data);
    }
    if (image_Ar_Data && image_Ar_Data !== "undefined" && image_Ar_Data !== "") {
      formData.append("image_ar", image_Ar_Data);
    }
    
    if (adPlace) {
      formData.append("adPlace", adPlace);
    }

    const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/ad_images`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.success) {
      return 200;
    } else {
      return 400;
    }
  } catch (err) {
    console.error("Error updating AdImages:", err);
    return 400;
  }
};

export default AdImagesCall;
